import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Player from './Player';
import { usePlayer } from '../context/PlayerContext';

const Layout = () => {
  const { currentSong } = usePlayer();

  return (
    <div className="app">
      <Navbar />
      <main className="main-content">
        <div className="container">
          <Outlet />
        </div>
      </main>
      {currentSong && <Player />}
    </div>
  );
};

export default Layout;
